import React, { MouseEvent } from 'react';
import { observer } from 'mobx-react';
import { Catcher, LoadingApiByTypeAndUnit } from '../../';
import { HorizontalUsageChart } from './';
import { useDashboardCountryUsageChart, useRouterStore, useUiEffectiveUnitType } from '../../../hooks';
import { getDashboardGraphTitleByUnitType } from '../../../middleware';
import { tP } from '../../../translate';
import Styles from '../m_dashboarStyles.less';

export const CountryUsage: React.FC = observer(() => {
    const unitType = useUiEffectiveUnitType();
    const routerStore = useRouterStore();
    const subTitle = getDashboardGraphTitleByUnitType(unitType);
    const title = `${tP('Top Countries')} ${subTitle}`;
    const apiTypeId = `GET_USAGE_COUNTRY_LIST`;
    const data = useDashboardCountryUsageChart(apiTypeId, unitType);
    const goToCardList = (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>): void => {
        event.preventDefault();
        routerStore.goTo('CountryList');
    };

    const titleLink = (): JSX.Element => (
        <a onClick={goToCardList} href={`/country`}>
            {title}
        </a>
    );

    const goToCountry = (id: string): void => {
        routerStore.goTo('Country', { params: { id } });
    };

    if (!unitType) {
        return null;
    }

    return (
        <Catcher>
            <LoadingApiByTypeAndUnit apiTypeId={apiTypeId} unitType={unitType} />
            <div className={Styles.chart}>
                <HorizontalUsageChart
                    sourceData={data}
                    title={title}
                    unitType={unitType}
                    titleLink={titleLink()}
                    onSelectRow={goToCountry}
                />
            </div>
        </Catcher>
    );
});
